import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './App.css';
import BibTeXEditor from './BibTeXEditor';
import { ToastProvider, useToast } from './Toast';
import { HelmetProvider } from 'react-helmet-async';
import GuidesHome from './components/Guides/GuidesHome';
import GuideDetail from './components/Guides/GuideDetail';
import { AuthProvider } from './contexts/AuthContext';
import AuthContext from './contexts/AuthContext';
import Login from './components/auth/Login';
import LoginSuccess from './components/auth/LoginSuccess';
import AdminLogin from './components/auth/AdminLogin';
import EmailVerification from './components/auth/EmailVerification';
import PasswordReset from './components/auth/PasswordReset';
import AcceptInvitation from './components/auth/AcceptInvitation';
import ProtectedRoute from './components/shared/ProtectedRoute';
import AdminDashboard from './components/admin/AdminDashboard';
import AccountSettings from './components/account/AccountSettings';
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
  useSortable,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import lavenderIconLight from './assets/blue_unfilled_icon_light.png';
import lavenderIconDark from './assets/lavender_unfilled_icon_dark.png';
import Projects from './components/projects/Projects';
import ProjectDetail from './components/projects/ProjectDetail';
import SortableCategoryGroup from './components/shared/SortableCategoryGroup';
import SortableReferenceCard from './components/shared/SortableReferenceCard';
import ReferenceCard from './components/references/ReferenceCard';
import ExportReferences from './components/references/ExportReferences';

const API_URL = '/api';

// Note: Authentication is now handled via httpOnly cookies
// The AuthContext sets up axios to send credentials with all requests
// No need for Bearer token interceptor here

function App() {
  return (
    <HelmetProvider>
      <ToastProvider>
        <AuthProvider>
          <Router>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/login-success" element={<LoginSuccess />} />
              <Route path="/the-librarian" element={<AdminLogin />} />
              <Route path="/verify-email" element={<EmailVerification />} />
              <Route path="/reset-password" element={<PasswordReset />} />
              <Route path="/accept-invitation" element={<AcceptInvitation />} />
              <Route path="/guides" element={<GuidesHome />} />
              <Route path="/guides/:slug" element={<GuideDetail />} />
              <Route path="/" element={
                <ProtectedRoute>
                  <Projects />
                </ProtectedRoute>
              } />
              <Route path="/projects/:id" element={
                <ProtectedRoute>
                  <ProjectDetailWrapper />
                </ProtectedRoute>
              } />
              <Route path="/admin" element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              } />
              <Route path="/account" element={
                <ProtectedRoute>
                  <AccountSettings />
                </ProtectedRoute>
              } />
            </Routes>
          </Router>
        </AuthProvider>
      </ToastProvider>
    </HelmetProvider>
  );
}

function ProjectDetailWrapper() {
  const params = window.location.pathname.split('/');
  const id = params[params.length - 1];
  return <ProjectDetail projectId={id} />;
}

export default App;